import React from 'react';
import Divider from '@material-ui/core/Divider';
import * as styles from './styles/styles.module.scss';

import FilterButton from '../FilterButton';
import ExpandableFilterPanel from '../ExpandableFilterPanel';

import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { FilterBarUtil } from '../../../utils/filter_bar_util';
import { logFilterSheetViewed } from '../../../utils/explore_analytics_helpers';
import { LOCATION_PAGE } from '../../../utils/constants/SearchAnalyticsConstants';

class FilterBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // probably want to move this element into its own component along with its style module
  getClearFiltersButton() {
    if (!this.props.isFilterActive) {
      return null;
    }
    return (
      <div key="clear-filters" className={styles.clearFilters} onClick={this.props.clearAllFilters}>
        {StringConstantsMixin.strings.CLEAR_FILTERS}
      </div>
    );
  }

  PanelItem(key, title, variant) {
    this.content = [];
    this.count = 0;
    this.activeCount = 0;
    this.addItem = (filter, filterContent) => {
      this.count++;
      this.activeCount += filterContent.active ? filterContent.active : 0;
      if (this.content.length) {
        this.content.push(<Divider key={`divider-${key}-${this.count}`} />);
      }
      return this.content.push(
        <ExpandableFilterPanel key={filter.key} title={filter.display} content={filterContent.component} truncate={filter.truncate} />
      );
    };
    this.getActiveCount = () => {
      return this.activeCount ? this.activeCount : '';
    };
    this.handleFilterButtonClick = (filterKey, isOpening) => {
      if (filterKey === 'more' && isOpening) {
        // Log event when the 'More filters' menu is opened
        logFilterSheetViewed(variant === 'seoPage' ? LOCATION_PAGE : variant);
      }
    };
    this.getContent = () => {
      return (
        <FilterButton
          variant={variant}
          key={key}
          filterKey={key}
          active={this.getActiveCount()}
          title={title}
          content={<div className={`${styles.panel} ${styles.nested}`}>{this.content}</div>}
          handleClick={this.handleFilterButtonClick}
        />
      );
    };
  }

  getFilterButtons = () => {
    const result = [];
    const Admin = new this.PanelItem('more_admin', 'Admin', this.props.variant);
    const Nested = new this.PanelItem('more', StringConstantsMixin.strings.FILTERS.MORE_FILTERS, this.props.variant);

    this.props.mappedFilters.forEach(filter => {
      if (this.props.enabledFilters.indexOf(filter.enabledKey) === -1) {
        return;
      }
      const filterContent = FilterBarUtil.getFilterContent(this.props, filter, filter.key);
      if (filter.admin) {
        // All Admin filters are clouds right now so this check will work. If you add a new type you might need to change this conditional (config keys length check)
        if (this.props.context && this.props.context.adminUser && Object.keys(filter.config).length) {
          Admin.addItem(filter, filterContent);
        }
      } else if (filter.nested) {
        Nested.addItem(filter, filterContent);
      } else {
        result.push(
          <FilterButton
            key={filter.key}
            title={filter.display}
            active={filterContent.active}
            content={filterContent.component}
            variant={this.props.variant}
          />
        );
      }
    });

    if (Nested.content.length) {
      result.push(Nested.getContent());
    }
    if (Admin.content.length && this.props.context && this.props.context.adminUser) {
      result.push(Admin.getContent());
    }
    result.push(this.getClearFiltersButton());
    return result;
  };

  render() {
    return <div className={`${styles.container} ${styles[this.props.variant]}`}>{this.getFilterButtons()}</div>;
  }
}

export default FilterBar;
